import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const FETCH_OPERATORS = createRequestTypes('placement/opsearch/FETCH_OPERATORS');
export const DEACTIVATE_FROM_APP = createRequestTypes('placement/opsearch/DEACTIVATE_FROM_APP');
export const RATE_LESS_THAN_MKT_RATE = createRequestTypes('placement/opsearch/RATE_LESS_THAN_MKT_RATE');
export const FO_RESPONSE_CONSIGNMENT = createRequestTypes('placement/opsearch/FO_RESPONSE_CONSIGNMENT');
export const FO_RESPONSE_QUOTATION = createRequestTypes('placement/opsearch/FO_RESPONSE_QUOTATION');
export const FO_RESPONSE_VEHICLE = createRequestTypes('placement/opsearch/FO_RESPONSE_VEHICLE');
export const FETCH_FEEDBACK_CONFIG = createRequestTypes('placement/opsearch/FETCH_FEEDBACK_CONFIG');
export const FETCH_FEEDBACK_VALUES = createRequestTypes('placement/opsearch/FETCH_FEEDBACK_VALUES');
export const SUBMIT_FEEDBACK = createRequestTypes('placement/opsearch/SUBMIT_FEEDBACK');
export const INITIATE_EXOTEL = createRequestTypes('placement/opsearch/INITIATE_EXOTEL');
export const SET_RESPONSE_ID = 'placement/opsearch/SET_RESPONSE_ID';
export const SET_SOURCE = 'placement/opsearch/SET_SOURCE';
export const CLEAR_OPERATOR_LIST = 'placement/opsearch/CLEAR_OPERATOR_LIST';
export const FETCH_OPERATOR_INFO = createRequestTypes('placement/opsearch/FETCH_OPERATOR_INFO');
export const SEND_TOKEN_LINK = createRequestTypes('placement/opsearch/SEND_TOKEN_LINK');
export const SEND_NOTIF_LINK = createRequestTypes('placement/opsearch/SEND_NOTIF_LINK');
export const RETRY_TOKEN_LINK = createRequestTypes('placement/opsearch/RETRY_TOKEN_LINK');
export const CONTROL_BOOKING_AUTOMATION = createRequestTypes('placement/opsearch/CONTROL_BOOKING_AUTOMATION');

export const fetchOperatorList = {
  request: (params) => createAction(FETCH_OPERATORS[REQUEST], { params }),
  success: (response, params) => createAction(FETCH_OPERATORS[SUCCESS], { response, params }),
  failure: (response) => createAction(FETCH_OPERATORS[FAILURE], { response }),
};

export const deactivateFromApp = {
  request: (params) => createAction(DEACTIVATE_FROM_APP[REQUEST], { ...params }),
  success: (response, params) => createAction(DEACTIVATE_FROM_APP[SUCCESS], { response, ...params }),
  failure: (response) => createAction(DEACTIVATE_FROM_APP[FAILURE], { response }),
};

export const rateLessThanMktRate = {
  request: (params) => createAction(RATE_LESS_THAN_MKT_RATE[REQUEST], { ...params }),
  success: (response, params) => createAction(RATE_LESS_THAN_MKT_RATE[SUCCESS], { response, ...params }),
  failure: (response) => createAction(RATE_LESS_THAN_MKT_RATE[FAILURE], { response }),
};

export const fetchFOResponseConsignment = {
  request: (params) => createAction(FO_RESPONSE_CONSIGNMENT[REQUEST], { ...params }),
  success: (response, params) => createAction(FO_RESPONSE_CONSIGNMENT[SUCCESS], { response, ...params }),
  failure: (response) => createAction(FO_RESPONSE_CONSIGNMENT[FAILURE], { response }),
};

export const fetchFOResponseQuotation = {
  request: (params) => createAction(FO_RESPONSE_QUOTATION[REQUEST], { ...params }),
  success: (response, params) => createAction(FO_RESPONSE_QUOTATION[SUCCESS], { response, ...params }),
  failure: (response) => createAction(FO_RESPONSE_QUOTATION[FAILURE], { response }),
};

export const fetchFOResponseVehicles = {
  request: (params) => createAction(FO_RESPONSE_VEHICLE[REQUEST], { ...params }),
  success: (response, params) => createAction(FO_RESPONSE_VEHICLE[SUCCESS], { response, ...params }),
  failure: (response) => createAction(FO_RESPONSE_VEHICLE[FAILURE], { response }),
};

export const fetchFeedbackConfig = {
  request: (params) => createAction(FETCH_FEEDBACK_CONFIG[REQUEST], { ...params }),
  success: (response, params) => createAction(FETCH_FEEDBACK_CONFIG[SUCCESS], { response, ...params }),
  failure: (response) => createAction(FETCH_FEEDBACK_CONFIG[FAILURE], { response }),
};

export const fetchFeedbackValues = {
  request: (params) => createAction(FETCH_FEEDBACK_VALUES[REQUEST], { ...params }),
  success: (response, params) => createAction(FETCH_FEEDBACK_VALUES[SUCCESS], { response, ...params }),
  failure: (response) => createAction(FETCH_FEEDBACK_VALUES[FAILURE], { response }),
};

export const submitFeedback = {
  request: (params) => createAction(SUBMIT_FEEDBACK[REQUEST], { ...params }),
  success: (response, params) => createAction(SUBMIT_FEEDBACK[SUCCESS], { response, ...params }),
  failure: (response) => createAction(SUBMIT_FEEDBACK[FAILURE], { response }),
};

export const initiateExotelCall = {
  request: (params) => createAction(INITIATE_EXOTEL[REQUEST], { ...params }),
  success: (response, params) => createAction(INITIATE_EXOTEL[SUCCESS], { response, ...params }),
  failure: (response) => createAction(INITIATE_EXOTEL[FAILURE], { response }),
};

export const resetResponseFO = (payload) => ({
  type: SET_RESPONSE_ID,
  payload,
});

export const setOpSearchSource = (payload) => ({
  type: SET_SOURCE,
  payload,
});

export const clearOperatorList = () => ({
  type: CLEAR_OPERATOR_LIST,
});

export const fetchOperatorInfo = {
  request: (params) => createAction(FETCH_OPERATOR_INFO[REQUEST], { ...params }),
  success: (response, params) => createAction(FETCH_OPERATOR_INFO[SUCCESS], { response, ...params }),
  failure: (response) => createAction(FETCH_OPERATOR_INFO[FAILURE], { response }),
};

export const sendTokenLink = {
  request: (params) => createAction(SEND_TOKEN_LINK[REQUEST], { ...params }),
  success: (response, params) => createAction(SEND_TOKEN_LINK[SUCCESS], { response, ...params }),
  failure: (response) => createAction(SEND_TOKEN_LINK[FAILURE], { response }),
};

export const retryTokenLink = {
  request: (params) => createAction(RETRY_TOKEN_LINK[REQUEST], { ...params }),
  success: (response, params) => createAction(RETRY_TOKEN_LINK[SUCCESS], { response }),
  failure: (response) => createAction(RETRY_TOKEN_LINK[FAILURE], { response }),
};

export const sendNotifications = {
  request: (params) => createAction(SEND_NOTIF_LINK[REQUEST], { ...params }),
  success: (response, params) => createAction(SEND_NOTIF_LINK[SUCCESS], { response, ...params }),
  failure: (response) => createAction(SEND_NOTIF_LINK[FAILURE], { response }),
};

export const controlBookingAutomation = {
  request: (params) => createAction(CONTROL_BOOKING_AUTOMATION[REQUEST], { ...params }),
  success: (response, params) => createAction(CONTROL_BOOKING_AUTOMATION[SUCCESS], { response, ...params }),
  failure: (response) => createAction(CONTROL_BOOKING_AUTOMATION[FAILURE], { response }),
};
